import { render, staticRenderFns } from "./OETGCacheTable.vue?vue&type=template&id=63f1915c&lang=pug&"
import script from "./OETGCacheTable.vue?vue&type=script&lang=js&"
export * from "./OETGCacheTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports